"use client";

import { useState, useRef } from "react";
import ReactPlayer from "react-player";
import { Play, Pause, Volume2, VolumeX } from "lucide-react";
import { Button } from "@/components/ui/button";

export function HeroVideo() {
  const [playing, setPlaying] = useState(false);
  const [muted, setMuted] = useState(true);
  const [hasStarted, setHasStarted] = useState(false);
  const playerRef = useRef<any>(null);

  const togglePlay = () => {
    if (playing) {
      setPlaying(false);
    } else {
      setPlaying(true);
      setHasStarted(true);
      setMuted(false); // Unmute when user explicitly plays
    }
  };

  const toggleMute = (e: React.MouseEvent) => {
    e.stopPropagation();
    setMuted(!muted);
  };

  return (
    <div className="relative w-full rounded-[24px] sm:rounded-[32px] md:rounded-[38px] border border-white/25 bg-white/10 p-1.5 sm:p-2 backdrop-blur-md">
      <div className="group relative aspect-video w-full min-h-[200px] sm:min-h-[280px] md:min-h-[320px] lg:min-h-[420px] overflow-hidden rounded-[20px] sm:rounded-[28px] md:rounded-[32px] bg-black/5">
        <ReactPlayer
          ref={playerRef}
          src="https://www.youtube-nocookie.com/watch?v=xNUx-rMGvvw"
          width="100%"
          height="100%"
          playing={playing}
          muted={muted}
          controls={false}
          playsInline
          config={{
            youtube: {
              playerVars: {
                modestbranding: 1,
                rel: 0,
                cc_load_policy: 0,
                iv_load_policy: 3,
                disablekb: 1,
                origin: typeof window !== "undefined" ? window.location.origin : "",
              },
            } as any,
          }}
          onPlay={() => {
            setPlaying(true);
            setHasStarted(true);
          }}
          onPause={() => setPlaying(false)}
        />

        {/* Controls Overlay */}
        <div className={`absolute inset-0 transition-opacity duration-300 ${hasStarted && playing ? "opacity-0 group-hover:opacity-100" : "opacity-100"}`}>
          {/* Play/Pause Button - Bottom Left */}
          <div className="absolute bottom-3 left-3 sm:bottom-4 sm:left-4 md:bottom-6 md:left-6 z-10">
            <Button
              onClick={togglePlay}
              size="icon"
              className="h-10 w-10 sm:h-12 sm:w-12 rounded-full border border-white/10 bg-black/40 text-white backdrop-blur-md transition-all duration-300 hover:scale-105 hover:bg-black/60"
            >
              {playing ? (
                <Pause className="h-5 w-5 fill-white" />
              ) : (
                <Play className="ml-0.5 h-5 w-5 fill-white" />
              )}
              <span className="sr-only">{playing ? "Pause" : "Play"} video</span>
            </Button>
          </div>

          {/* Sound Control - Bottom Right */}
          <div className="absolute bottom-3 right-3 sm:bottom-4 sm:right-4 md:bottom-6 md:right-6 z-10">
            <Button
              onClick={toggleMute}
              size="icon"
              variant="secondary"
              className="h-10 w-10 sm:h-12 sm:w-12 rounded-full border border-white/10 bg-black/40 text-white backdrop-blur-md transition-all duration-300 hover:scale-105 hover:bg-black/60"
            >
              {muted ? (
                <VolumeX className="h-5 w-5" />
              ) : (
                <Volume2 className="h-5 w-5" />
              )}
              <span className="sr-only">Toggle sound</span>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
